import classNames from 'classnames'
import React, { useEffect, useMemo, useState } from 'react'
import { TimerHook } from '../../hooks/useTimer'
import { SlideshowTimer } from './ControlledSlideshowNavigation'

export interface DotProgressProps {
  active: boolean
  color: string
  onClickTimer: TimerHook
  paused?: boolean
  timer: SlideshowTimer
}

export const DotProgress = ({
  active,
  color,
  onClickTimer,
  paused,
  timer,
}: DotProgressProps) => {
  // Animation reset should be faster than "timer"
  const resetDuration = 0.4
  const baseClassName = useMemo(
    () => `${color} block absolute top-0 h-full transition-all ease-linear rounded-5`,
    [color]
  )

  const [className, setClassName] = useState(classNames(baseClassName, 'left-0 w-0'))
  const [duration, setDuration] = useState(resetDuration)

  useEffect(() => {
    if (active) {
      if (timer !== 'disabled') {
        if (onClickTimer.isRunning()) {
          setDuration(resetDuration)
        } else {
          // Allow the progress bar to be filled for a short while
          // before switching to avoid a too hasty transition.
          // Hence the arbitrary 0.8 second subtraction
          setDuration(timer - 0.8)
        }
      }

      if (onClickTimer.isRunning()) {
        // Use a different animation fade-in when the user clicks on a dot
        setClassName(classNames(baseClassName, 'animate-slideshow-dots-fade-in'))
      } else {
        setClassName(classNames(baseClassName, 'animate-slideshow-dots'))
      }
    } else {
      if (timer !== 'disabled') {
        setDuration(resetDuration)
      }

      setClassName(classNames(baseClassName, 'animate-slideshow-dots-exit'))
    }
  }, [active, baseClassName, onClickTimer, timer])

  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        animationDuration: `${duration}s`,
        animationPlayState: paused ? 'paused' : undefined,
      }}
    ></span>
  )
}
